/**
 * Shared by `WidgetInspector.tsx` (kpi/chart metrics) and `TablePanel.tsx`
 * (table column rollups) — both edit the same `Metric` shape and need the
 * same "keep the column the person already picked" behavior when the
 * aggregation changes underneath it, and the same plain-language name for
 * each aggregation so it never reads two different ways in the same UI.
 */
/** Sentence-case labels for each aggregation kind (spec §6.3, §10.2). */
export const METRIC_LABEL = {
    sum: 'Total',
    count: 'Count',
    average: 'Average',
    ratio_of_sums: 'Ratio'
};
/** Which column id a metric reads, for the purpose of "keep the current
 *  column when the aggregation changes". `ratio_of_sums` has two; the
 *  numerator stands in since that is what a person is most likely adjusting. */
export function metricColumnId(metric) {
    switch (metric.kind) {
        case 'sum':
        case 'average':
            return metric.columnId;
        case 'count':
            return metric.columnId;
        case 'ratio_of_sums':
            return metric.numeratorColumnId;
    }
}
/** Rebuilds a metric when the aggregation changes, keeping the current column
 *  when the new aggregation can still accept it. Returns null when the dataset
 *  cannot satisfy the requested aggregation at all. */
export function retargetMetric(kind, current, numeric) {
    const held = metricColumnId(current);
    const heldIsNumeric = held !== undefined && numeric.some((c) => c.id === held);
    switch (kind) {
        case 'count':
            return held !== undefined ? { kind: 'count', columnId: held } : { kind: 'count' };
        case 'sum':
        case 'average': {
            const columnId = heldIsNumeric ? held : numeric[0]?.id;
            return columnId ? { kind, columnId } : null;
        }
        case 'ratio_of_sums': {
            const numerator = heldIsNumeric ? held : numeric[0]?.id;
            if (!numerator)
                return null;
            const denominator = numeric.find((c) => c.id !== numerator)?.id ?? numerator;
            return { kind: 'ratio_of_sums', numeratorColumnId: numerator, denominatorColumnId: denominator };
        }
    }
}
//# sourceMappingURL=metricEditing.js.map